import Checkbox from '@/components/ui/Checkbox';
import { FormControl, FormField, FormItem } from '@/components/ui/Form';

import { useLingui } from '@lingui/react';
import { useFormContext } from 'react-hook-form';

const CheckboxWithoutStreet = ({
  prefix,
  disabled,
}: {
  prefix: string;
  disabled?: boolean;
}) => {
  const { i18n } = useLingui();
  const { setValue, clearErrors } = useFormContext();
  return (
    <FormField
      name={`${prefix}.without_street`}
      defaultValue={false}
      render={({ field }) => (
        <FormItem className="col-span-4">
          <FormControl>
            <Checkbox
              label={i18n.t('Adres bez ulicy')}
              checked={!!field.value}
              disabled={disabled}
              data-testid={`without-street-${prefix}`}
              onCheckedChange={(checked) => {
                field.onChange(!!checked);
                if (checked) {
                  setValue(`${prefix}.address`, '');
                  clearErrors(`${prefix}.address`);
                }
              }}
            />
          </FormControl>
        </FormItem>
      )}
    />
  );
};

export default CheckboxWithoutStreet;
